<script lang="ts">
  //App.svelte
  import { QueryClientProvider, QueryClient } from "@sveltestack/svelte-query";
  interface Props {
    children?: import('svelte').Snippet;
  }

  let { children }: Props = $props();
  export const queryClient = new QueryClient();
</script>

<QueryClientProvider client={queryClient}>
  {@render children?.()}
</QueryClientProvider>
